import React, { useState } from 'react';
import { Minus, Plus } from 'phosphor-react';

const QuantityInput = ({
  value,
  onChange,
  onBlur,
  onQuantityIncrease,
  onQuantityDecrease,
  increaseDisabled,
  decreaseDisabled,
  maxQuantity,
  showButtons = true,
  disabled = false,
}) => {
  const [active, setActive] = useState(false);

  return (
    <div className={`quantity-input ${active ? 'active' : ''}`}>
      {!disabled && showButtons && <Minus onClick={!decreaseDisabled ? onQuantityDecrease : undefined} />}
      <div>
      <input
        disabled={disabled}
        type="number"
        value={value}       
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => {
          setActive(false);
          onBlur && onBlur(e);
        }}
        onFocus={() => setActive(true)}
      />
      {maxQuantity ?<span className='quantity-input__max-quant'>{`/${maxQuantity}`}</span> : ''}
      </div>
      {!disabled && showButtons && <Plus onClick={!increaseDisabled ? onQuantityIncrease : undefined} />}
    </div>
  );
};

export default QuantityInput;
